var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 72,
    height: 72,
    fill: "#F9FAFB",
    stroke: "#D2D2D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1484 37.4871L38.6348 38.9418V65.0908L61.2694 52.0221V25.873L41.1484 37.4871Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.247 14.039L36.5423 9L13.2793 22.4295L21.9956 27.4684L45.247 14.039Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7945 22.4307L49.7631 16.7168L26.5117 30.1463L27.8384 30.8329L36.5431 35.8602L45.2013 30.8678L59.7945 22.4307Z",
    fill: "#565656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7545 39.7573L20.5883 37.6161V30.9595L12 26.0137V51.9765L34.4717 64.9521V38.9893L24.7545 33.3917V39.7573Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcelIcon);
export default __webpack_public_path__ + "static/media/parcel_icon.227db56740e06e925ae1fbcfb9ddc0ed.svg";
export { ForwardRef as ReactComponent };